import React from "react"
import classNames from "classnames"
import {ManagedSolutionsCard} from "../../../containers/ManagedSolutionsCard/ManagedSolutionsCard"

interface LegalTermsCardProps {
	mainDisclaimer?: {
		id: string
		description: string | string[]
	}
	className?: string
}

export function LegalTermsCard({mainDisclaimer, className}: LegalTermsCardProps) {
	if (!mainDisclaimer) {
		return null
	}

	const descriptionArray = Array.isArray(mainDisclaimer.description)
		? mainDisclaimer.description
		: [mainDisclaimer.description]
	// For RTL banking users, only show the first paragraph
	const firstParagraph = descriptionArray[0]

	return (
		<ManagedSolutionsCard className={classNames("legal-terms-card", className)}>
			<div className="legal-terms-card-content">
				<span className="legal-terms-card-paragraph">{firstParagraph}</span>
			</div>
		</ManagedSolutionsCard>
	)
}
